module.exports = __webpack_public_path__ + "img/fin_05_守护树苗.8945c3f6.jpg";